import { Button, Text } from '@pentabd/ui';
import { Link } from 'react-router-dom';

import { useLanguage } from '@hooks/useLanguage';

import IMAGE from './../../images/404.svg';

const NoMatch = () => {
  const { language } = useLanguage();
  return (
    <div className="d-flex  flex-column justify-content-center align-items-center vh-100">
      <div className="mb-9">
        <img src={IMAGE} alt="not-found" />
      </div>

      <Text sizeType="display" size="sm" color="dark" weight="semibold">
        {language === 'bn'
          ? 'দুঃখিত। পৃষ্ঠা খুঁজে পাওয়া যায়নি'
          : ' Oops! Page not found'}
      </Text>
      <br />
      <Text size="md" weight="normal">
        {language === 'bn'
          ? 'পৃষ্ঠাটি সঠিকভাবে লোড করা যায়নি। পৃষ্ঠাটি রিফ্রেশ করার চেষ্টা করুন।'
          : 'Sorry the page could not load properly. Try refreshing the page.'}
      </Text>

      <Link to="/" className="mt-9">
        <Button fill="fill" type="primary">
          {language === 'bn' ? 'রিফ্রেশ করুন' : 'Click to refresh'}
        </Button>
      </Link>
    </div>
  );
};

export default NoMatch;
